/** Presentation-only number formatting helpers for the analytics inspector. */

const usdFull = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const usdCompact = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

const integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export function formatUsd(value: number): string {
  return usdFull.format(value);
}

export function formatUsdCompact(value: number): string {
  return usdCompact.format(value);
}

export function formatUsdCents(value: number): string {
  return `$${value.toFixed(2)}`;
}

/** RASM / CASM per available seat mile, e.g. "$0.0912". */
export function formatPerAsm(value: number): string {
  return `$${value.toFixed(4)}`;
}

export function formatInt(value: number): string {
  return integer.format(value);
}

export function formatPct(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

/** Signed percentage, e.g. "+4.2%" / "-12.0%". */
export function formatSignedPct(value: number, digits = 1): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(digits)}%`;
}

/** US cents, e.g. "11.42¢". */
export function formatCents(value: number, digits = 2): string {
  return `${value.toFixed(digits)}¢`;
}

/** Signed percentage points, e.g. "+3.1 pts" / "-4.0 pts". */
export function formatSignedPts(value: number, digits = 1): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(digits)} pts`;
}
